// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { H3, Link } from '@codex/basics';

const Wrapper = styled(H3)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.header.nav.mobile.titleMain};
  font-size: 16px;
  font-weight: 600;
  padding: 15px 5px;
  margin: 0;
  margin: 0 10px 4px 10px;
`;

const Overview = styled(Link)`
  border: 1px solid ${({ theme }) => theme.colors.link.default};
  color: ${({ theme }) => theme.colors.link.default};
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;

  &:hover {
    text-decoration: none;
  }
`;

const NavigationHeading = (props) => {
  const { currentSubmenu } = props;
    
  return (
    <Wrapper>
      { !currentSubmenu ? 'Main menu' : currentSubmenu.label }
      {
        currentSubmenu && (
          <Overview href={currentSubmenu.link}>Overview</Overview>
        )
      }
    </Wrapper>
  );
};

NavigationHeading.propTypes = {
  currentSubmenu: PropTypes.oneOfType([
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
      nav: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]))
    }),
    PropTypes.bool
  ])
};

NavigationHeading.defaultProps = {
  currentSubmenu: false
};

export default NavigationHeading;
